class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.predictiveSearchInner = this.querySelector('.header__search-inner');
    this.predictiveSearchBackdrop = this.querySelector('.header__search-backdrop');

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }




  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const isUnsupportedLocale = document.documentElement.lang === 'ko';
    const url = isUnsupportedLocale
      ? `${routes.search_url}?q=${encodeURIComponent(searchTerm)}&type=product&section_id=predictive-search`
      : `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=4&section_id=predictive-search`;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').querySelector('#predictive-search-results').innerHTML;
        if(resultsMarkup.length > 0){
          this.cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
        }else{
          this.close();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    if(resultsMarkup.length > 0) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
    }else{
      this.close();
    }
  }




  open() {
    this.predictiveSearchInner.classList.add('show');
    this.predictiveSearchBackdrop.classList.add('show');
  }

  close() {
    this.predictiveSearchInner.classList.remove('show');
    this.predictiveSearchBackdrop.classList.remove('show');
  }
}

customElements.define('predictive-search', PredictiveSearch);
